import React from "react";
import "../Style/ContentCard.css"


const ContentCard = ({ skin }) => {
  return (
    <div className="content-main-container">
      <div>
        <h1 className="skin-head-1">{skin.heading.heading}</h1>
        <p className="skin-head-para">{skin.heading.para}</p>
      </div>
      <div className="content-card">
        {skin.content.map((content) => (
          <div className="content-card-1">
            <div>
              <img src={content.imageUrl} />
            </div>
            <p className="content-name-p"> {content.name}</p>
            <p className="content-desc-p">{content.desc}</p>
            <button className="content-btn">Know more</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentCard;
